import { OhsActionsRecord } from 'action/OhsActionModels';
import { ModuleType, OhsModuleCreateBy } from 'global-services/constants/OhsObject';
import OhsCusvalValue from 'global-components/form/cusvals/OhsCusvalValue';
import { OhsCusval } from 'global-components/form/cusvals/OhsCusvalModel';
import { OhsAttachment } from 'global-components/form/fields/attachments/OhsAttachmentModels';

export default class OhsDocumentTaskRecord {
  attachments: OhsAttachment[];

  complete: boolean;

  reviewNotes: string;

  createdBy: OhsModuleCreateBy;

  dateCreated: string;

  dateDue: string;

  dateCompleted: string;

  dateSignedoff: string;

  signedoffBy: {
    name: string;
    email: string;
  };

  description: string;

  for?: { _id: string; type: ModuleType.VersionDocument };

  links: OhsActionsRecord[];

  type: ModuleType.Task;

  tzDateCreated: string;

  _id: string;

  constructor() {
    this.attachments = [];
    this.complete = false;
    this.reviewNotes = '';
    this.createdBy = new OhsModuleCreateBy();
    this.dateCreated = '';
    this.dateDue = '';
    this.dateCompleted = '';
    this.dateSignedoff = '';
    this.signedoffBy = {
      name: '',
      email: '',
    };
    this.description = '';
    this.for = undefined;
    this.links = [];
    this.type = ModuleType.Task;
    this.tzDateCreated = '';
    this._id = '';
  }
}

export interface OhsDocumentTaskResponse extends OhsDocumentTaskRecord {
  categoryCusvals?: OhsCusvalValue;

  subcategoryCusvals?: OhsCusvalValue;
}

export interface OhsDocumentTaskFormatted extends OhsDocumentTaskRecord {
  categoryCusvals?: OhsCusval[];

  subcategoryCusvals?: OhsCusval[];
}
